const ALLOWED_CONTENT_TYPES_VIDEO = ['video/mp4', 'video/quicktime'];
const ALLOWED_CONTENT_TYPES_IMAGE = ['image/bmp', 'image/jpeg', 'image/png'];
const ALLOWED_CONTENT_TYPES_DOCUMENT = [
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.oasis.opendocument.presentation',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/zip',
  'multipart/x-zip',
  'application/zip-compressed',
  'application/x-zip-compressed',
  'application/octet-stream',
];

export const ALLOWED_CONTENT_TYPES = [
  ...ALLOWED_CONTENT_TYPES_VIDEO,
  ...ALLOWED_CONTENT_TYPES_IMAGE,
  ...ALLOWED_CONTENT_TYPES_DOCUMENT,
];

export const ALLOWED_EXTENSIONS_IMAGE_UPLOAD = ['jpg', 'jpeg', 'png', 'gif'];
export const FILE_MAX_SIZE = 2000000; // 2Mo

export const UPLOAD_ERROR_TYPE = {
  TYPE: 'TYPE',
  SIZE: 'SIZE',
};
